import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { OilSupplierService } from "../../openapi";
import { OilSupplierMutationKeys } from "./constants";
import { OilSupplierQueryKeys } from "../queries/constants";

export const useDeleteOilSupplierMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [OilSupplierMutationKeys.DELETE_OIL_SUPPLIER],
    mutationFn: (id: string) => OilSupplierService.oilSupplierControllerDelete(id),
    onSuccess: () => {
      toast.success("Xóa nhà cung cấp xăng dầu thành công!");
      queryClient.invalidateQueries({
        queryKey: [OilSupplierQueryKeys.GET_OIL_SUPPLIERS],
      });
    },
    onError: () => {
      toast.error("Xóa nhà cung cấp xăng dầu thất bại!");
    },
  });
};
